import React from "react";
export default function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-14">
      <h1 className="font-heading text-4xl font-bold text-gray-900">Terms of Service</h1>
      <p className="mt-4 text-gray-700 leading-relaxed">By using Access Local, you agree to use the service lawfully and respectfully. Ratings and reviews should reflect genuine, first-hand experience. Access Local reserves the right to remove content that is inaccurate, defamatory or otherwise inappropriate.</p>
      <h2 className="mt-8 font-heading text-2xl font-semibold text-gray-900">Content</h2>
      <p className="mt-2 text-gray-700 leading-relaxed">You retain ownership of content you submit, but grant Access Local a licence to display and moderate it as part of the platform.</p>
      <h2 className="mt-8 font-heading text-2xl font-semibold text-gray-900">Changes</h2>
      <p className="mt-2 text-gray-700 leading-relaxed">These terms may be updated. Continued use of the service constitutes acceptance of the current terms.</p>
    </div>
  );
}
